<mat-accordion class="marge">
    <!-- #enddocregion basic-panel -->
    <mat-expansion-panel [expanded]="panelOpenState === true" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                {{Question.title}}
            </mat-panel-title>
            <mat-panel-description *ngIf="option.result != ''">
                {{option.result}}
            </mat-panel-description>
            <div class="valid" *ngIf="show">Répondu</div>
            <div class="invalid" *ngIf="!show">En cours</div>
        </mat-expansion-panel-header>
        <mat-form-field appearance="fill">
            <mat-label>Entrez une heure</mat-label>
            <input matInput type="time" [(ngModel)]="option.result" (ngModelChange)="searchLink()" title="Entrez une heure">
        </mat-form-field>
    </mat-expansion-panel>
</mat-accordion>

<div *ngIf="questions.length > 0 && show">
    <div *ngFor="let q of questions">
        <app-generic-display [Question]="q" [SurveyBase]="SurveyBase"></app-generic-display>
    </div>
</div>